import { useEffect, useRef, useState } from 'react'
import { ApiError } from 'queries/fetchData'

const useCountdown = (
    initialCount: number,
    onComplete: () => void,
    error?: unknown,
) => {
    const [count, setCount] = useState(initialCount)
    const onCompleteRef = useRef(onComplete)
    const wasUnauthorizedRef = useRef(false)
    const hasCompletedRef = useRef(false)
    const isUnauthorized = error instanceof ApiError && error.status === 401

    useEffect(() => {
        onCompleteRef.current = onComplete
    }, [onComplete])

    useEffect(() => {
        if (!isUnauthorized) {
            setCount(initialCount)
            hasCompletedRef.current = false
            wasUnauthorizedRef.current = false
            return
        }

        if (!wasUnauthorizedRef.current) {
            setCount(initialCount)
            hasCompletedRef.current = false
        }

        wasUnauthorizedRef.current = true
    }, [initialCount, isUnauthorized])

    useEffect(() => {
        if (!isUnauthorized || hasCompletedRef.current) {
            return
        }

        if (count <= 0) {
            hasCompletedRef.current = true
            onCompleteRef.current()
            return
        }

        const timer = window.setTimeout(() => {
            setCount((prevCount) => Math.max(prevCount - 1, 0))
        }, 1000)

        return () => window.clearTimeout(timer)
    }, [count, isUnauthorized])

    return count
}

export default useCountdown
